var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{attrs:{"fill":"#017A75"}},[_c('g',{staticClass:"nc-loop-dots-4-24-icon-f"},[_c('circle',{attrs:{"cx":"4","cy":"12","fill":"#017A75","r":"3"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"3","fill":"#017A75"}}),_c('circle',{attrs:{"cx":"20","cy":"12","fill":"#017A75","r":"3"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }